var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-radio",on:{"click":_vm.emitChange}},[(_vm.isSelected || _vm.storedValue === _vm.value)?_c('i',{staticClass:"fad fa-circle icon"}):_c('i',{staticClass:"far fa-circle icon"}),_c('span',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }